export default {
  alexName: "",
  conversationData: [],
};
